export default {
  alexName: "",
  conversationData: [],
};
